import { render, staticRenderFns } from "./SlotsLogTabs.vue?vue&type=template&id=0f012c22&lang=pug"
import script from "./SlotsLogTabs.vue?vue&type=script&lang=js"
export * from "./SlotsLogTabs.vue?vue&type=script&lang=js"
import style0 from "./SlotsLogTabs.vue?vue&type=style&index=0&id=0f012c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports